import * as React from "react";
import {useAuth} from './AuthContext'
import { returnBasenameUrl } from "../utils";

const opercategoryexample = [
    1,
    "00..",
    "MCs, ATVs, UVs, PWC;Tune-up & Adjustment",
    "00..",
    "MC, ATV, UV, PWC; Συντονισμός &; Προσαρμογή"
]

export type WarrOpType = typeof opercategoryexample
export type WarrOpCategoryType = typeof opercategoryexample
export type WarrOpCategoriesType =  Array<typeof opercategoryexample>

// const OpCodesItem =  [
//     "AO",
//     "Scratched"
// ]
const OpCodesItem = [ "AO",  "Scratched",  "Γρατζουνισμένο" ]


// export type OpCodesItemType = {
//     item: typeof OpCodesItem
// }
export type OpCodesItemType =  typeof OpCodesItem

export type OpCodeCategType = {
    groupid: string,
    groupname: string,
    groupname_el: string,
    items: Array<OpCodesItemType>
}

export type warrFieldConfigType = {
    required: boolean,
    datatype: string
}
export type warrclaimconfigType = {
    maxnumofimagesperclaim: number,
    maxbytesperimage: number,
    allowableimagetypes: string[],
    allowableimageext: string[],
    custname: warrFieldConfigType,
    custaddr: warrFieldConfigType,
    custzip: warrFieldConfigType,
    custcity: warrFieldConfigType,
    custcountry: warrFieldConfigType,
    custmobile: warrFieldConfigType,
    custemail: warrFieldConfigType
}


export type opscodesDataType = {
    warrops: Array<WarrOpType>,
    faultypes: Array<OpCodeCategType>,
    troubles: Array<OpCodeCategType>,
    reasons: Array<OpCodeCategType>, 
    warrclaimconfig?: warrclaimconfigType
}

export type claimcfgType = {
    success: boolean,
    data: warrclaimconfigType
}

export type WarrOpsCodesResponseType = {
    fetched: boolean
    success: boolean    
    reply?: string
    totalcount?: number
    procstep?: number
    error?: string
    data?: opscodesDataType
}

const warrcodegroupexample ={
    "groupid": "poorappearance",
    "groupname": "Poor appearance",
    "groupname_el": "Κακή εμφάνιση"
}


export const InitialWarrClaimCfg: warrclaimconfigType =  {
        maxnumofimagesperclaim: 5,
        maxbytesperimage: 4000000,
        allowableimagetypes: ["image/jpeg","image/png"],
        allowableimageext: [".jpg", ".jpeg" , ".png"],
        custname: {"required":false,"datatype":"string"},
        custaddr: {"required":false,"datatype":"string"},
        custzip: {"required":false,"datatype":"string"},
        custcity: {"required":false,"datatype":"string"},
        custcountry: {"required":false,"datatype":"string"},
        custmobile: {"required":false,"datatype":"string"},
        custemail: {"required":false,"datatype":"string"}
}

function getInitialState():WarrOpsCodesResponseType { 
    // const warrOpscontextdata = sessionStorage.getItem('ksrgrb2b_WarrOpsCodes_context')
    return {fetched: false, success: false}
}

// function getIinitWarrOpsCateg():WarrOpsCategCntxtDatatype { 
//     const strwarrOpscontextdata = sessionStorage.getItem('ksrgrb2b_WarrOps_context')
//     if(strwarrOpscontextdata){
//         const warrOpscontextdata:WarrOpsDataType = JSON.parse(strwarrOpscontextdata)
//         if(warrOpscontextdata)
//             if(warrOpscontextdata.fetched==true && warrOpscontextdata.success==true && warrOpscontextdata.warrops && warrOpscontextdata.warrops?.length>0){
//                 const warropsCategories = warrOpscontextdata.warrops.filter((warrop) => warrop[1].toString().substring(2,4)=="..");
//                 return {fetched: true, success: true, categories: warropsCategories}
//             }
//             else return  {fetched: false, success: false}
//         else return  {fetched: false, success: false}
//     }
//     else return  {fetched: false, success: false}
// }

// async function saveWarrOpsContext(warrOpscontextdata: any):Promise<any>{
//     sessionStorage.setItem("ksrgrb2b_WarrOps_context", JSON.stringify(warrOpscontextdata));
// }

interface WarrOpsCodesContextType {
    warrOpsCodesContextdata: WarrOpsCodesResponseType, 
    // // warrOpsCategscontextdata:WarrOpsCategCntxtDatatype,
    setWarropscodescontext: () => void ;
    clearWarropscodescontext: () => void ;
    getwarrclaimconfig: () => warrclaimconfigType|null;
    getWarrOps: () => (string|number)[][]|null;
    getWarrOpsCategs: () => WarrOpCategoriesType|null;
    getfaultypes: () => OpCodeCategType[]|null;
    getFaulttypesGroups: () => (typeof warrcodegroupexample)[]|null
    gettroubles: () => OpCodeCategType[]|null;
    getTroublesGroups: () => (typeof warrcodegroupexample)[]|null
    getreasons: () => OpCodeCategType[]|null;
    getReasonsGroups: () => (typeof warrcodegroupexample)[]|null
}

let WarrOpsCodesContext = React.createContext<WarrOpsCodesContextType>(null!); 


function WarrOpsCodesContextProvider({ children }: { children: React.ReactNode }) {
    let [warrOpsCodesContextdata, setwarrOpsCodesContextdata] = React.useState<WarrOpsCodesResponseType>(getInitialState); //  React.useState<any>(null);
    let auth = useAuth();
    console.log("WarrOpsContextProvider startup, warrOpsCodesContextdata=",warrOpsCodesContextdata)
    let warropscodesData:WarrOpsCodesResponseType={ 
        fetched: false, 
        success: false,
        error: ""
    }
    // React.useEffect(() => {
    //     sessionStorage.setItem('ksrgrb2b_WarrOpsCodes_context', JSON.stringify(warrOpsCodesContextdata))
    // },[warrOpsCodesContextdata]);

    let setWarropscodescontext = () => { 
        console.log("WarrOpsCodesContextProvider setWarropscodescontext, called")
        if(auth.userData === undefined || auth.userData === null ||
        auth.userData.userid===null || auth.userData.userid===undefined || auth.userData.userid<=0 || 
        auth.userData.success===undefined || auth.userData.success===null ||auth.userData.success===false)
        {
            console.log("WarrOpsCodesContextProvider setWarropscodescontext, not authenticted")
            setwarrOpsCodesContextdata(getInitialState())
        }
        else {
            /* bypass ajax because it is only 9999 mark for now ... */
            const ms = Date.now();
            let basename=returnBasenameUrl()
            let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}&fetch=warropsandtypes&appId=${process.env.REACT_APP_APPID}`;

            console.log("WarrOpsCodesContextProvider setWarropscodescontext, fetching context...")

            fetch(url, { method: 'GET' }
            )
            .then((response) =>  {
                if (!response.ok) {
                    console.log('WarrOpsCodesContextProvider setWarropscodescontext response not ok=',response)
                    warropscodesData.success=false;
                    warropscodesData.fetched=true;
                    warropscodesData.error="Bad setWarropscontext Response";
                    return {}
                }
                else {
                    console.log('WarrOpsCodesContextProvider setWarropscodescontext response ok=',response)
                    return response.json()
                }
            })
            .then((data:any) => {
                console.log('WarrOpsCodesContextProvider setWarropscodescontext response=',data)
                if(data.success===undefined || data.success===null){
                    warropscodesData.success=false;
                    warropscodesData.fetched=true;
                    warropscodesData.error="Bad Json Response";
                    console.log('WarrOpsCodesContextProvider setWarropscodescontext response=',"Bad Json Response")
                }
                else {
                    if(data.success===true){
                        console.log('WarrOpsCodesContextProvider setWarropscodescontext response=',"data.success===true")
                        warropscodesData.success= data.success
                        warropscodesData.fetched=true;
                        warropscodesData.data= data.data; 

                    }
                    else {
                        console.log('WarrOpsCodesContextProvider setWarropscodescontext response=',"data.success===false")
                    }
                }
            })
            .catch((err) => {
                console.log("WarrOpsCodesContextProvider setWarropscodescontext exception=",err.message);
                warropscodesData.success=false;
                warropscodesData.fetched=true;
                warropscodesData.error="WarrOpsCodesContextProvider setWarropscodescontext exception";        
            })
            .finally(() => {
              
                setwarrOpsCodesContextdata(warropscodesData); 
            
            })   
        }
    };

    let clearWarropscodescontext = () => {
        setwarrOpsCodesContextdata(getInitialState())
    };

    let getWarrOps = () => {
        if(warrOpsCodesContextdata)
            if(warrOpsCodesContextdata.fetched==true && warrOpsCodesContextdata.success==true && warrOpsCodesContextdata.data
                && warrOpsCodesContextdata.data.warrops
                && warrOpsCodesContextdata.data.warrops.length>0  ) {
                return warrOpsCodesContextdata.data.warrops;
            }
            else return  null
        else return  null
    }

    let getWarrOpsCategs = () =>{
        if(warrOpsCodesContextdata)
            if(warrOpsCodesContextdata.fetched==true && warrOpsCodesContextdata.success==true && warrOpsCodesContextdata.data
                && warrOpsCodesContextdata.data.warrops 
                && warrOpsCodesContextdata.data.warrops.length>0  ) {
                return warrOpsCodesContextdata.data.warrops.filter((warrop) => warrop[1].toString().substring(2,4)=="..") as WarrOpCategoriesType;
            }
            else return  null
        else return  null
    } ;
    
    let getfaultypes = () =>{
        if(warrOpsCodesContextdata)
            if(warrOpsCodesContextdata.fetched==true && warrOpsCodesContextdata.success==true && warrOpsCodesContextdata.data
                && warrOpsCodesContextdata.data.faultypes
                && warrOpsCodesContextdata.data.faultypes.length>0  ) {
                return warrOpsCodesContextdata.data.faultypes;
            }
            else return  null
        else return  null
    } ;

    let getFaulttypesGroups = () => {
        if(warrOpsCodesContextdata)
            if(warrOpsCodesContextdata.fetched==true && warrOpsCodesContextdata.success==true && warrOpsCodesContextdata.data
                && warrOpsCodesContextdata.data.faultypes
                && warrOpsCodesContextdata.data.faultypes.length>0  ) {
                    let arrf: typeof warrcodegroupexample[] = []
                    warrOpsCodesContextdata.data.faultypes.map((item)=>{
                        arrf.push({
                            groupid: item.groupid,
                            groupname: item.groupname,
                            groupname_el: item.groupname_el
                        })
                    })
                    if(arrf.length>0) return arrf
                    else return null
            }
            else return  null
        else return  null
    }

    let gettroubles = () =>{
        if(warrOpsCodesContextdata)
            if(warrOpsCodesContextdata.fetched==true && warrOpsCodesContextdata.success==true && warrOpsCodesContextdata.data
                && warrOpsCodesContextdata.data.troubles
                && warrOpsCodesContextdata.data.troubles.length>0  ) {
                return warrOpsCodesContextdata.data.troubles;
            }
            else return  null
        else return  null
    } ;

    let getTroublesGroups = () => {
        if(warrOpsCodesContextdata)
            if(warrOpsCodesContextdata.fetched==true && warrOpsCodesContextdata.success==true && warrOpsCodesContextdata.data
                && warrOpsCodesContextdata.data.troubles
                && warrOpsCodesContextdata.data.troubles.length>0  ) {
                    let arrf: typeof warrcodegroupexample[] = []
                    warrOpsCodesContextdata.data.troubles.map((item)=>{
                        arrf.push({
                            groupid: item.groupid,
                            groupname: item.groupname,
                            groupname_el: item.groupname_el
                        })
                    })
                    if(arrf.length>0) return arrf
                    else return null
            }
            else return  null
        else return  null
    }

    let getreasons = () =>{
        if(warrOpsCodesContextdata)
            if(warrOpsCodesContextdata.fetched==true && warrOpsCodesContextdata.success==true && warrOpsCodesContextdata.data
                && warrOpsCodesContextdata.data.reasons
                && warrOpsCodesContextdata.data.reasons.length>0  ) {
                return warrOpsCodesContextdata.data.reasons;
            }
            else return  null
        else return  null
    } ;

    let getReasonsGroups = () => {
        if(warrOpsCodesContextdata)
            if(warrOpsCodesContextdata.fetched==true && warrOpsCodesContextdata.success==true && warrOpsCodesContextdata.data
                && warrOpsCodesContextdata.data.reasons
                && warrOpsCodesContextdata.data.reasons.length>0  ) {
                    let arrf: typeof warrcodegroupexample[] = []
                    warrOpsCodesContextdata.data.reasons.map((item)=>{
                        arrf.push({
                            groupid: item.groupid,
                            groupname: item.groupname,
                            groupname_el: item.groupname_el
                        })
                    })
                    if(arrf.length>0) return arrf
                    else return null
            }
            else return  null
        else return  null
    }

    let getwarrclaimconfig = () =>{
        let def_warrclaimconfig = {
            "maxnumofimagesperclaim": 5,
            "maxbytesperimage": 4000000,
            "allowableimagetypes": ["image/jpeg","image/png"],
            "allowableimageext": [".jpg", ".jpeg" , ".png"],
            "custname": {"required":false,"datatype":"string"},
            "custaddr": {"required":false,"datatype":"string"},
            "custzip": {"required":false,"datatype":"string"},
            "custcity": {"required":false,"datatype":"string"},
            "custcountry": {"required":false,"datatype":"string"},
            "custmobile": {"required":false,"datatype":"string"},
            "custemail": {"required":false,"datatype":"string"}
        } 
        if(warrOpsCodesContextdata){
            if(warrOpsCodesContextdata.fetched==true && warrOpsCodesContextdata.success==true && warrOpsCodesContextdata.data
                && warrOpsCodesContextdata.data.warrclaimconfig && Object.keys(warrOpsCodesContextdata.data.warrclaimconfig).length ) {
                if('maxnumofimagesperclaim' in warrOpsCodesContextdata.data.warrclaimconfig) def_warrclaimconfig.maxnumofimagesperclaim = warrOpsCodesContextdata.data.warrclaimconfig.maxnumofimagesperclaim;
                if('maxbytesperimage' in warrOpsCodesContextdata.data.warrclaimconfig)  def_warrclaimconfig.maxbytesperimage = warrOpsCodesContextdata.data.warrclaimconfig.maxbytesperimage;
                if('allowableimagetypes' in warrOpsCodesContextdata.data.warrclaimconfig) def_warrclaimconfig.allowableimagetypes = warrOpsCodesContextdata.data.warrclaimconfig.allowableimagetypes;
                if('allowableimageext' in warrOpsCodesContextdata.data.warrclaimconfig)  def_warrclaimconfig.allowableimageext = warrOpsCodesContextdata.data.warrclaimconfig.allowableimageext;
            }
        }
        return def_warrclaimconfig
    }

    let value = { 
        warrOpsCodesContextdata, 
        setWarropscodescontext,
        clearWarropscodescontext,
        getwarrclaimconfig,
        getWarrOps,
        getWarrOpsCategs,
        getfaultypes,
        getFaulttypesGroups,
        gettroubles,
        getTroublesGroups,
        getreasons,
        getReasonsGroups
    };
    return <WarrOpsCodesContext.Provider value={value}>{children}</WarrOpsCodesContext.Provider>;

}
function useWarrOpsCodesContext() {
    return React.useContext(WarrOpsCodesContext);
}

export {WarrOpsCodesContextProvider, WarrOpsCodesContext, useWarrOpsCodesContext}
